import React, { useRef } from "react";
import ScrolImg from "../images/MouseMinimalistic.png";
import { Link } from "react-router-dom";
import menu_logo from "../images/menu-vector.png";

export const Navbar = () => {
  const scrollToRef = useRef(null);

  const handleButtonClick = () => {
    scrollToRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div className="banner_container">
      <div className="header bg-transparent" id="header">
        <div className="container">
          <div className="row mb-2 py-3 px-lg-5">
            <div className="col-6 text-start text-white">
              <h1>STYLENOVA.AI</h1>
            </div>

            <div className="col-6 d-flex align-items-center justify-content-end">
            <div className="d-none d-md-flex header-data d-flex gap-5">
            <Link className="header_data_a text-white text-decoration-none" to="/join_now"> Join Now </Link>
            <Link className="header_data_a text-white text-decoration-none"to="/sign_in" > Sign In </Link>
            </div>
            <div className="d-md-none header-data d-flex gap-5">
            <div className="dropdown">
                <button className="btn btn-secondary dropdown-toggle bg-transparent border-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <img src={menu_logo} alt="logo" className="img-fluid" />
                </button>
                <div className="dropdown-menu bg-transparent" aria-labelledby="dropdownMenuButton">
                <Link className="dropdown-item header_data_a text-white text-decoration-none" to="/join_now"> Join Now </Link>
                <Link className="dropdown-item header_data_a text-white text-decoration-none" to="/sign_in" > Sign In </Link>
                </div>
            </div>
            </div>
        </div>
          </div>
          <div className="row justify-content-center">
            <button
              className="btn btn-primary ScrolDown_button"
              onClick={handleButtonClick}
              style={{ width: "150px" }}
            >
              <p>Scroll to bottom</p>
              <img src={ScrolImg} alt="img" />
            </button>
          </div>
        </div>
      </div>

      <div style={{ height: "120vh", width: "100%" }}></div>
      <div ref={scrollToRef} style={{ height: "100vh" }}></div>
    </div>
  );
};

export default Navbar;
